import React from 'react';
import styled from 'styled-components';
import { Flex, Typo, theme } from '../../../ui';
import { toRgba } from '../../../ui/theme/colors';
import Icon from '../../../ui/Icon';
import { media } from '../../../utils/media';

const OverviewContainer = styled.div`
  background: ${theme.colors.NEU_0};
  border-radius: 16px;
  padding: 24px 28px;
  box-shadow: 0 2px 12px ${toRgba(theme.colors.NEU_999, 0.06)};
  max-width: 60%;

  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;
  flex: 1;
  min-width: 0;

  ${media.lessThan('bigTablet')} {
    align-items: flex-start;
    flex-direction: column;
  }

  ${media.lessThan('tablet')} {
    flex: 0;
    max-width: 100%;
    align-items: center;
    align-self: center;
  }
`;

const TitleSection = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;

  ${media.lessThan('tablet')} {
    justify-content: space-between;
  }

  ${media.lessThan('phablet')} {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
`;

const StatsGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-evenly;
  ${media.lessThan('tablet')} {
    gap: 40px;
  }
`;

const StatCard = styled(Flex)`
  border-radius: 10px;
  transition: all 0.3s ease;
`;

const IconWrapper = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: ${(props) => props.$bgColor};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
`;

const StatValue = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: ${(props) => props.$brandColor || theme.colors.NEU_PRIMARY};
  margin-bottom: 2px;
`;

const StatLabel = styled.div`
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.5px;
  color: ${(props) => props.$brandColor || theme.colors.NEU_600};
  text-transform: uppercase;
`;

const OverviewCard = ({ title, stats = [] }) => {
  return (
    <OverviewContainer>
      <TitleSection>
        <Typo.ContentSmallHeader $textAlign='left' color={theme.colors.NEU_PRIMARY}>
          {title}
        </Typo.ContentSmallHeader>
      </TitleSection>

      <StatsGrid>
        {stats.map((stat, index) => {
          const StatIcon = Icon[stat.icon];
          return (
            <StatCard key={index} direction='column' align='center'>
              <IconWrapper $bgColor={stat.bgColor}>{StatIcon && <StatIcon size={'small'} color={stat.color} />}</IconWrapper>
              <StatValue $brandColor={stat.color}>{stat.value}</StatValue>
              <StatLabel $brandColor={stat.labelColor}>{stat.label}</StatLabel>
            </StatCard>
          );
        })}
      </StatsGrid>
    </OverviewContainer>
  );
};

export default OverviewCard;
